import type { Organization } from '@/types';

/** Optional legal identity stored under `organizations.settings.legalIdentity`. */
export interface LegalIdentity {
  name?: string;
  idNumber?: string;
}

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value);

const readTrimmed = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() ? value.trim() : undefined;

/**
 * Read `settings.legalIdentity` (nombre de sociedad / cédula) from an organization.
 * Empty or whitespace-only values are treated as unset; never throws.
 */
export const resolveLegalIdentity = (
  settings: Organization['settings'] | undefined | null,
): LegalIdentity => {
  if (!isPlainObject(settings)) return {};

  const legalIdentity = settings.legalIdentity;
  if (!isPlainObject(legalIdentity)) return {};

  return {
    name: readTrimmed(legalIdentity.name),
    idNumber: readTrimmed(legalIdentity.idNumber),
  };
};
